import React, { Component } from "react";
import {
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  Table,
  Button,
  Input
} from "reactstrap";
import { reduxForm } from 'redux-form'
import { connect } from 'react-redux';
import BlockUi from 'react-block-ui';
import 'react-block-ui/style.css';
import { storedb } from '../../views/client/storedb'
import { settingListRequest, settingUpdateStoreRequest } from './actions'
import { SETTING_LIST_SUCCESS } from './constants'
import Messages from '../../notifications/Messages'
import Errors from '../../notifications/Errors'
import { BtnPermissions, BtnType } from '../../lib/BtnPermissions';
import { ButtonExt } from "../controls/ButtonExt"
import { ImageUpload } from "../controls/_ImageUpload"
import { inputFileType } from "../../lib/common"
class Setting extends Component {
  constructor(props) {
    super(props);
    var dbContext = storedb();
    this.state = {
      storeId: dbContext.getStoreId(),
      item: {},
      list: [],
      files: null
    };
  }
  handleControlChange = (id, e) => {
    var listItem = this.state.list;
    var index = listItem.findIndex(x => x.IdS === id);
    if (index > -1) {
      if (e.target.type && e.target.type == "checkbox") {
        listItem[index].SettingValue = listItem[index].SettingValue == "0" ? 1 : 0
      } else {
        listItem[index].SettingValue = e.target.value
      }
      this.setState({ list: listItem });
    }
  }
  handleImageChange = (imageData, idSetting) => {
    var listItem = this.state.list;
    var index = listItem.findIndex(x => x.IdS === idSetting);
    if (index > -1) {
      listItem[index].FileData = imageData
      this.setState({ list: listItem });
    }
  }
  SaveSetting = () => {
    var requestData = {
      storeId: this.state.storeId,
      items: this.state.list
    }
    this.props.settingUpdateStoreRequest(requestData, (data) => {
      setTimeout(this.fetchList, 1000)
    })
  }
  fetchList = (e) => {
    const { settingListRequest } = this.props
    var requestData = {
      storeId: this.state.storeId,
    }
    return settingListRequest(requestData)
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.setting.type == SETTING_LIST_SUCCESS) {
      let { list, item } = nextProps.setting;
      this.setState({
        list: list,
      });
    }
  }

  componentDidMount() {
    this.fetchList()
  }
  render() {
    const {
      setting: {
        listRequesting,
        messages,
        errors,
        requesting,
      },
    } = this.props
    const { list } = this.state
    const listInput = list.filter(v => v.InputType != inputFileType.TEXTAREA)
    const listTexarea = list.filter(v => v.InputType == inputFileType.TEXTAREA)
    return (
      <div className="animated fadeIn">
        <BlockUi tag="div" blocking={listRequesting}>
          <Row>
            <Col>
              <Card>
                <CardHeader>
                  <i className="fa fa-cogs"></i> Thiết lập giá trị trước khi sử dụng phần mềm
              </CardHeader>
                <CardBody className="card-body">
                  <Table hover responsive className="table-outline mb-0 d-sm-table table-sm">
                    <thead className="thead-default">
                      <tr>
                        <th scope="col" style={{ width: "30%" }} className="text-left">Nội dung cài đặt</th>
                        <th scope="col" style={{ width: "70%" }} className="text-center">Giá trị</th>
                      </tr>
                    </thead>
                    <tbody>
                      {listInput && !!listInput.length && (
                        listInput.map((res, idx) => (
                          <tr key={res.IdS}>
                            <td className="text-left">
                              {res.GhiChu}
                            </td>
                            <td className="text-right">
                              {res.InputType == inputFileType.INPUT ? <Input type="text" onChange={this.handleControlChange.bind(this, res.IdS)}
                                className="form-control form-control-sm text-right" value={res.SettingValue || ''}></Input> : ""}
                              {res.InputType == inputFileType.CHECKBOX ? 
                               <label className="checkcustom" htmlFor={`${res.SettingId}-${idx}`} style={{margin: 1}}>
                                  <Input 
                                  style={{ position: "relative" }} 
                                  type="checkbox" 
                                  id={`${res.SettingId}-${idx}`}
                                  checked={(res.SettingValue == "0" || res.SettingValue == "") ? false : true} 
                                  onChange={this.handleControlChange.bind(this, res.IdS)}></Input> 
                                  <span className="checkmark"></span>
                              </label>
                              : ""}
                              {res.InputType == inputFileType.IMAGE ? <ImageUpload maxSize={512000} onChangeFile={this.handleImageChange} idSetting={res.IdS} fileData = {res.FileData}/> : ""}
                            </td>
                          </tr>
                        ))
                      )}
                      {listTexarea && !!listTexarea.length && (
                        listTexarea.map((res, idx) => (
                          <tr key={res.IdS}>
                            <td className="text-left" colSpan="2">
                              {res.GhiChu}
                              <div>
                                <textarea maxLength={1000} className="form-control form-control-sm"
                                  value={res.SettingValue || ''}
                                  onChange={this.handleControlChange.bind(this, res.IdS)} />
                              </div>
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </Table>
                  <Row className="mt-3">
                    <div className="col-sm-6">
                      <ButtonExt btnClass="pull-right mr-1"
                        color="primary"
                        iconClass="fa-save "
                        displayText="Lưu"
                        btnClick={() => this.SaveSetting()}
                        permission={BtnPermissions.Setting.ADD_OR_UPDATE} />
                    </div>
                  </Row>
                  <Row>
                    <Col md="12">
                      {!requesting && !!errors.length && (
                        <Errors errors={errors} />
                      )}
                      {!requesting && !!messages.length && (
                        <Messages messages={messages} />
                      )}
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </BlockUi>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  setting: state.setting,
  client: state.client,
})

const connected = connect(mapStateToProps, {
  settingListRequest,
  settingUpdateStoreRequest
})(Setting)

const formed = reduxForm({
  form: 'setting',
})(connected)

export default formed;



// WEBPACK FOOTER //
// ./src/views/Setting/Setting.js